<template>
  <div class="selection-group">
    <selection-button
      v-for="(item, index) in items"
      :key="item.title"
      v-bind="item"
      :selected="index === selectedIndex"
      @select="onSelect(index)"
    />
  </div>
</template>

<script>
import SelectionButton from './SelectionButton';

export default {
  name: 'SelectionGroup',
  components: {
    SelectionButton,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    initialSelectionIndex: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      selectedIndex: this.initialSelectionIndex,
    };
  },
  methods: {
    onSelect(index) {
      this.selectedIndex = index;
      this.$emit('select', index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/spacings';

.selection-group {
  display: flex;
  flex-direction: column;
  row-gap: $ri-spacing-s;
}
</style>
